export const projects = [
  {
    name: "The Game of Life",
    imgURL: "https://i.imgur.com/kKJxjwd.png",
    liveURL: "https://game-of-life-39.vercel.app/",
    githubURL: "https://github.com/christiano39/game_of_life",
  },
  {
    name: "My Weather",
    imgURL: "https://i.imgur.com/6sX2rgl.png",
    liveURL: "https://my-weather-39.vercel.app/",
    githubURL:
      "https://github.com/christiano39/weather/tree/master/weather-app",
  },
  {
    name: "Crypto Tracker",
    imgURL: "https://i.imgur.com/ostW5t4.png",
    liveURL: "https://crypto-graphs.vercel.app/charts",
    githubURL: "https://github.com/christiano39/dark-mode",
  },
];
